import { format, subDays } from 'date-fns'

import { SignalUsage } from '../types/signalUsage'

export const getUsageDateRange = (today = new Date()) => ({
  fromDate: format(subDays(today, 29), 'yyyyMMdd'),
  toDate: format(today, 'yyyyMMdd'),
})

export const sumSignalUsage = (entries: SignalUsage[]) => {
  const clicks = entries.flatMap((entry) => (entry.clicks == null ? [] : [entry.clicks]))
  const conversions = entries.flatMap((entry) =>
    entry.conversions == null
      ? []
      : [
          Array.isArray(entry.conversions)
            ? entry.conversions.reduce((total, conversion) => total + conversion.count, 0)
            : entry.conversions,
        ],
  )
  return {
    clicks: clicks.length ? clicks.reduce((total, count) => total + count, 0) : null,
    conversions: conversions.length ? conversions.reduce((total, count) => total + count, 0) : null,
  }
}
